<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('dharma.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item
            :to="applicable_books_route"
            v-if="group == 'applicable'"
          >{{ $t('dharma.list.application.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item
            :to="downloadable_books_route"
            v-if="group == 'downloadable'"
          >{{ $t('dharma.list.download.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-nav pills fill>
          <b-nav-item-dropdown
            :text="$t('dharma.list.application.title')"
            :toggle-class="group == 'applicable' ? 'active' : ''"
          >
            <b-dropdown-item
              :to="applicable_books_route"
              :active="group == 'applicable' && type == 'book'"
            >{{ $t('dharma.list.book.title') }}</b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'dharmas', params: { group: 'applicable', type: 'picture' } }"
              :active="group == 'applicable' && type == 'picture'"
            >{{ $t('dharma.list.picture.title') }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            :text="$t('dharma.list.download.title')"
            :toggle-class="group == 'downloadable' ? 'active' : ''"
          >
            <b-dropdown-item
              :to="downloadable_books_route"
              :active="group == 'downloadable' && type == 'book'"
            >{{ $t('dharma.list.book.title') }}</b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'dharmas', params: { group: 'downloadable', type: 'picture' } }"
              :active="group == 'downloadable' && type == 'picture'"
            >{{ $t('dharma.list.picture.title') }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item
            :to="{ name: 'dharmas-search' }"
            :active="group === '' && type === ''"
          >{{ $t('dharma.list.search.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <div class="row mt-3" v-if="group == 'applicable'">
      <div class="col-12">
        <application-list-button-toolbar></application-list-button-toolbar>
      </div>
    </div>
    <div class="row mt-3" v-if="group == 'applicable'">
      <div class="col-12">
        <book-language-selector-button
          :languages="languages"
          @select="redirectToSpecificLanguageBooks"
          v-if="type == 'book'"
        ></book-language-selector-button>
        <b-button
          variant="link"
          target="_blank"
          href="https://www2.budaedu.org/dharma-data/dharmas.xlsx"
        >{{ $t('dharma.list.application.link.master-list-download') }}</b-button>
      </div>
    </div>
    <div class="row mt-3" v-if="type == 'book' && language != ''">
      <div class="col-12">
        <h4>{{ $t('dharma.list.book.label.selected-language') }}：{{ $i18n.locale === 'tw' ? selected_language.chinese_name : selected_language.english_name }}</h4>
      </div>
    </div>

    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col-12">
          <b-form-select v-model="per_page" :options="per_page_options"></b-form-select>
        </div>
      </div>
      <book-card-list
        v-if="type === 'book'"
        :books="dharmas"
        :applicable="group == 'applicable'"
      ></book-card-list>
      <picture-card-list
        v-if="type === 'picture'"
        :pictures="dharmas"
        :applicable="group == 'applicable'"
      ></picture-card-list>
      <div class="row mt-3" v-if="group == 'applicable' && show_next_page_notice">
        <div class="col-12">
          <b-alert show class="text-center font-weight-bold mb-0 border-0" style="font-size: 1.75rem; background-color: #F7F4EF; color: #ff3030;">
            {{ $t('dharma.list.modal.next-page-notice.message') }}
          </b-alert>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-pagination
            size="lg"
            align="center"
            v-model="page"
            :total-rows="dharmas_meta.total"
            :per-page="per_page"
            @change="pageChange"
          ></b-pagination>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import BookLanguageSelectorButton from '@/components/buttons/BookLanguageSelectorButton.vue'
import ApplicationListButtonToolbar from '@/components/button-toolbars/application-list-button-toolbar/ApplicationListButtonToolbar'
import BookCardList from '@/components/lists/BookCardList'
import PictureCardList from '@/components/lists/PictureCardList'

import i18n from '@/plugins/i18n.js'

import BookApiService from '@/services/budaedu-api-services/book-api-service.js'
import BookLanguageApiService from '@/services/budaedu-api-services/book-language-api-service.js'
import PictureApiService from '@/services/budaedu-api-services/picture-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(ListGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)

Vue.use(BookApiService)
Vue.use(BookLanguageApiService)
Vue.use(PictureApiService)

export default {
  i18n,
  name: 'dharmas',
  props: {
    group: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      is_loading: false,
      dharmas: [],
      dharmas_meta: { total: 0, current_page: null, last_page: null },
      page: 1,
      dharma: {},
      dharma_image: {},
      dharma_efiles: [],
      dharma_downloadable_efile: null,
      dharma_printable_efile: null,
      languages: [],
      selected_language: {}
    }
  },
  computed: {
    applicable_books_route() {
      return {
        name: 'dharmas',
        params: { group: 'applicable', type: 'book' },
        query: { language: (this.$i18n.locale === 'tw' ? 'chinese' : 'english') }
      }
    },
    downloadable_books_route() {
      return {
        name: 'dharmas',
        params: { group: 'downloadable', type: 'book' },
        query: { language: (this.$i18n.locale === 'tw' ? 'chinese' : 'english') }
      }
    },
    per_page() {
      return this.type === 'book' ? 30 : 30
    },
    per_page_options() {
      return [
        { value: 30, text: this.$t('paginator.items-per-page-selector.option.label', { size: 30 }) },
        { value: 50, text: this.$t('paginator.items-per-page-selector.option.label', { size: 50 }) },
        { value: 100, text: this.$t('paginator.items-per-page-selector.option.label', { size: 100 }) },
        { value: 200, text: this.$t('paginator.items-per-page-selector.option.label', { size: 200 }) }
      ]
    },
    show_next_page_notice() {
      return this.dharmas_meta.last_page &&
        this.dharmas_meta.current_page &&
        this.dharmas_meta.last_page > this.dharmas_meta.current_page &&
        this.dharmas.filter(dharma => dharma.in_stock == 'Y').length == this.per_page
    }
  },
  watch: {
    per_page(new_value, old_value) {
      this.page = 1
      this.setDharmasAndPaging()
    }
  },
  methods: {
    redirectToSpecificLanguageBooks(language_english_name) {
      this.$router.push({
        name: 'dharmas',
        params: { type: 'book' },
        query: { language: language_english_name.toLowerCase() }
      });
    },
    pageChange(page) {
      this.page = page
      this.setDharmasAndPaging()
    },
    getBooksOrder() {
      switch (this.group) {
        case 'applicable':
          return 'latest_storage_date,desc|order_by_language_category_count,asc|code,desc'
        case 'downloadable':
          return 'order_by_language_category_count,asc|code,asc'
        default:
          return 'code,asc'
      }
    },
    getPicturesOrder() {
      switch (this.group) {
        case 'applicable':
          return this.$i18n.locale === 'tw'
            ? 'in_stock,asc|chinese_display_order,asc|latest_storage_date,desc|created_at,desc'
            : 'in_stock,asc|english_display_order,asc|latest_storage_date,desc|created_at,desc'
        case 'downloadable':
          return this.$i18n.locale === 'tw'
            ? 'chinese_display_order,asc|code,asc'
            : 'english_display_order,asc|code,asc'
        default:
          return 'code,asc'
      }
    },
    async setDharmasAndPaging() {
      this.is_loading = true
      this.dharmas = []
      
      try {
        let items = {}
        let preview = { url: 'img/common.jpg' }

        if (this.type == 'book') {
          items = await this.$bookApiService.queryByLanguage(
            this.language,
            `filter[have_efile]&order=${this.getBooksOrder()}&per_page=${this.per_page}&page=${this.page}`
          )

          const previewPromises = items.data.map(async (book) => {
            book.front_cover = await this.$bookApiService.getFrontCover(book, preview)
          })
          await Promise.all(previewPromises)
        } else if (this.type == 'picture') {
          items = await this.$pictureApiService.query(
            `filter[have_efile]&order=${this.getPicturesOrder()}&per_page=${this.per_page}&page=${this.page}`
          )

          const previewPromises = items.data.map(async (picture) => {
            picture.preview = await this.$pictureApiService.getPreviewableEfile(picture, preview)
          })
          await Promise.all(previewPromises);
        }
        
        this.dharmas = items.data
        this.dharmas_meta = items.meta
      } finally {
        this.is_loading = false
      }
    },
    async setLanguages() {
      let order = ''
      switch (this.$i18n.locale) {
        case 'tw':
          order = 'chinese_display_order,asc|english_name,asc'
          break
        case 'en':
          order = 'english_display_order,asc|english_name,asc'
          break
        default:
          order = 'english_display_order,asc|english_name,asc'
      }

      const items = await this.$bookLanguageApiService.queryTopLevel(`order=${order}`)
      this.languages = items.data
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setLanguages()
    await this.setDharmasAndPaging()
    if (this.type == 'book' && this.language != '') {
      this.selected_language = this.languages.find(item => item.english_name.toLowerCase() == this.language)
    }
  },
  components: {
    ApplicationListButtonToolbar,
    BookCardList,
    BookLanguageSelectorButton,
    PictureCardList
  },
  metaInfo() {
    const titles = {
      applicable: {
        book: `${this.$t('dharma.list.application.title')}-${this.$t('dharma.list.book.title')}`,
        picture: `${this.$t('dharma.list.application.title')}-${this.$t('dharma.list.picture.title')}`
      },
      downloadable: {
        book: `${this.$t('dharma.list.download.title')}-${this.$t('dharma.list.book.title')}`,
        picture: `${this.$t('dharma.list.download.title')}-${this.$t('dharma.list.picture.title')}`
      }
    }

    return {
      title: titles[this.group][this.type],
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>
